import axios from "axios";
import * as BusEvents from "../constants/bus-events";
import * as Actions from "./constants/actions";
import * as Mutations from "./constants/mutations";

export default {
    [Actions.UPDATE_USER]({ commit }) {
        axios.get("/user").then((response) => {
            commit(Mutations.UPDATE_AUTH_USER, response.data);
        });
    },
    [Actions.FETCH_CORPORATIONS]({ commit, state }) {
        return axios
            .get(`/web-api/corporation`, {
                params: {
                    include: state.corporations.meta.include
                }
            })
            .then((res) => {
                commit(Mutations.SET_CORPORATIONS, res.data);
                window.Bus.$emit(BusEvents.CORPORATIONS_FETCHED);
            });
    },
    [Actions.FETCH_COMMUNITIES]({ commit, state }) {
        return axios
            .get(`/web-api/community`, {
                params: {
                    all: 0, //for backend pagination
                    include: "address,logo,formatted_logo,locations"
                }
            })
            .then((res) => {
                commit(Mutations.SET_COMMUNITIES, res.data);
                window.Bus.$emit(BusEvents.COMMUNITIES_FETCHED);
            });
    },
    [Actions.FETCH_COMMUNITIES_ALL]({ commit, state }) {
        return axios
            .get(`/web-api/community`, {
                params: {
                    all: 1, // for frontend pagination
                    include: "address,logo,formatted_logo,locations"
                }
            })
            .then((res) => {
                commit(Mutations.SET_COMMUNITIES, res.data);
                window.Bus.$emit(BusEvents.COMMUNITIES_FETCHED);
            });
    },
    [Actions.FETCH_COMMUNITIES_MIN]({ commit, state }) {
        return axios.get(`/web-api/getCommunityNames`).then((res) => {
            commit(Mutations.SET_COMMUNITIES, res);
            window.Bus.$emit(BusEvents.COMMUNITIES_FETCHED);
        });
    },
    [Actions.FETCH_USERS]({ commit, state }) {
        return axios
            .get(`/web-api/user`, {
                params: {
                    include: state.users.meta.include,
                    filter: { status: "active" },
                    all: 0 //for backend pagination
                }
            })
            .then((res) => {
                commit(Mutations.SET_USERS, res.data);
            });
    },
    [Actions.FETCH_USERS_ALL]({ commit, state }) {
        return axios
            .get(`/web-api/user`, {
                params: {
                    include: state.users.meta.include,
                    all: 1 // for frontend pagination
                }
            })
            .then((res) => {
                commit(Mutations.SET_USERS, res.data);
            });
    },
    [Actions.FETCH_ORDERS]({ commit, state }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/web-api/order`, {
                    params: {
                        include: state.orders.meta.include,
                        pending: 1
                    }
                })
                .then((res) => {
                    commit(Mutations.SET_ORDERS, res.data);
                    resolve(res);
                })
                .catch((errors) => reject(errors));
        });
    },
    [Actions.FETCH_SIZES]({ commit, state }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/web-api/size`)
                .then((res) => {
                    commit(Mutations.SET_SIZES, res.data);
                    resolve(res);
                    window.Bus.$emit(BusEvents.SIZES_FETCHED, res.data);
                })
                .catch((errors) => reject(errors));
        });
    },
    [Actions.FETCH_DIGITAL_FILES]({ commit, state }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/web-api/digital-file`)
                .then((res) => {
                    commit(Mutations.SET_DIGITAL_FILES, res.data);
                    resolve(res);
                    window.Bus.$emit(BusEvents.DIGITAL_FILES_FETCHED, res.data);
                })
                .catch((errors) => reject(errors));
        });
    },
    [Actions.FETCH_NOTIFICATIONS]({ commit, state }, params) {
        params = {
            ...{
                page: 1,
                per_page: 10
            },
            ...params
        };
        return axios
            .get(`/web-api/notification`, {
                params
            })
            .then((res) => {
                commit(Mutations.SET_NOTIFICATIONS, res.data);
                return res;
            })
            .catch((errors) => console.log(errors));
    },
    [Actions.FETCH_CART]({ commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/web-api/cart`)
                .then((res) => {
                    commit(Mutations.SET_CART, res.data);
                    resolve(res);
                })
                .catch((errors) => reject(errors));
        });
    },
    [Actions.FETCH_CART_TAX]({ commit }) {
        return new Promise((resolve, reject) => {
            commit(Mutations.SET_LOADING_CART_TAX, true);
            axios
                .post(`/web-api/cart/compute-tax`)
                .then((res) => {
                    let tax = null;
                    if (res.data && !_.isString(res.data)) {
                        // check if backend returned a tax object
                        tax = res.data;
                    }
                    commit(Mutations.SET_CART_TAX, tax);
                    resolve(res);
                })
                .catch((errors) => reject(errors))
                .finally(() => {
                    commit(Mutations.SET_LOADING_CART_TAX, false);
                });
        });
    },
    [Actions.FETCH_CURRENT_COMMUNITY]({ commit, state }) {
        return axios
            .get(
                `/web-api/community/${state.current_community.id}?include=logo,formatted_logo,locations,corporation.discount,corporation.logo,address,custom_charges`
            )
            .then((response) => {
                commit(Mutations.SET_CURRENT_COMMUNITY, response.data);
                return response;
            });
    },
    [Actions.FETCH_CURRENT_CORPORATION]({ commit, state }) {
        return new Promise((resolve, reject) => {
            axios
                .get(
                    `/web-api/corporation/${state.current_corporation.id}?include=logo`
                )
                .then((res) => {
                    commit(Mutations.SET_CURRENT_CORPORATION, res.data);
                    resolve(res);
                })
                .catch((errors) => reject(errors));
        });
    },
    [Actions.FETCH_DISCOUNTS]({ commit, state }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/web-api/discount`)
                .then((res) => {
                    commit(Mutations.SET_DISCOUNTS, res.data);
                    resolve(res);
                })
                .catch((errors) => reject(errors));
        });
    },
    [Actions.UPDATE_COMMUNITY]({ commit, state }, { id }) {
        return new Promise((resolve, reject) => {
            axios
                .get(
                    `/web-api/community/${id}?include=${state.communities.meta.include}`
                )
                .then((res) => {
                    commit(Mutations.UPDATE_COMMUNITY, res.data);
                    resolve(res);
                })
                .catch((errors) => reject(errors));
        });
    },
    [Actions.SKIP_MONTH]({ commit, state }) {
        return axios.post(`/web-api/calendar/skip-month`).then(() => {
            commit(Mutations.SET_CURRENT_CALENDAR_MONTH, {
                year: state.current_community.current_month.year,
                month: state.current_community.current_month.month + 1
            });
        });
    },
    [Actions.FETCH_CURRENT_ORDER]({ commit, state }) {
        return axios
            .get(`/web-api/order/current`, {
                params: {
                    include: "shipping_rate"
                }
            })
            .then((response) => {
                commit(Mutations.SET_CURRENT_ORDER, response.data);
                return response;
            });
    },
    [Actions.FETCH_PRICES]({ commit }) {
        return axios.get(`/web-api/price`).then((response) => {
            commit(Mutations.SET_PRICES, response.data);
            return response;
        });
    },
    [Actions.FETCH_STATES]({ commit }) {
        return axios.get(`/web-api/state`).then((response) => {
            commit(Mutations.SET_STATES, response.data);
            return response;
        });
    },
    fetchHandlingCharge({ commit }) {
        commit("SET_LOADING_HANDLING_CHARGE", true);
        return axios
            .get("/web-api/cart/handling-charge")
            .then((response) => {
                commit("SET_HANDLING_CHARGE", response.data);
            })
            .catch((error) => {
                console.log(error);
                commit("SET_HANDLING_CHARGE", null);
            })
            .finally(() => {
                commit("SET_LOADING_HANDLING_CHARGE", false);
            });
    }
};
